// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"XjNT8a","container":"Dbbp4k"};